import {
  RiLineChartLine,
  RiMenuLine,
  RiShoppingCart2Line,
  RiToolsLine,
} from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { i18n } from "../../../localization/i18n";
import { MenuButton, MenuItemContainer } from "../styles";

interface MenuListProps {
  extendedMode: boolean;
}

export const EmployeeMenuList = ({ extendedMode }: MenuListProps) => {
  const location = useLocation();

  const tooltipProps = {
    tooltip: {
      sx: {
        backgroundColor: "var(--dark-gray)",
        color: "var(--white)",
        fontSize: "14px",
        fontWeight: "500",
        padding: "8px 14px",
        borderRadius: "6px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
      }
    },
    arrow: {
      sx: {
        color: "var(--dark-gray)"
      }
    }
  };
  
  return (
    <>
      <MenuItemContainer>
        <Link to="/employee/dashboard">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.reports")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/employee/dashboard")}>
                <div className="content">
                  <RiLineChartLine size={24} />
                  <span>{`${i18n.t("sidebar.reports")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/employee/orders">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.requests")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/employee/orders")}>
                <div className="content">
                  <RiMenuLine size={24} />
                  <span>{`${i18n.t("sidebar.requests")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/employee/plans">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.plans")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/employee/plans")}>
                <div className="content">
                  <RiShoppingCart2Line size={24} />
                  <span>{`${i18n.t("sidebar.plans")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>

      <MenuItemContainer>
        <Link to="/configs">
          <Tooltip 
            title={extendedMode ? "" : `${i18n.t("sidebar.config")}`} 
            placement="right" 
            arrow 
            disableHoverListener={extendedMode}
            componentsProps={tooltipProps}
          >
            <span style={{ display: 'block' }}>
              <MenuButton extendedMode={extendedMode} isActive={location.pathname.includes("/configs")}>
                <div className="content">
                  <RiToolsLine size={24} />
                  <span>{`${i18n.t("sidebar.config")}`}</span>
                </div>
              </MenuButton>
            </span>
          </Tooltip>
        </Link>
      </MenuItemContainer>
    </>
  );
};

